import React, { useState, useEffect } from 'react';
import { Button, Flex, Layout, List, Menu, Skeleton, Space, theme } from 'antd';
import { UpOutlined, RightOutlined, HomeFilled, AppstoreOutlined, MailOutlined, SettingOutlined, StarOutlined, DownloadOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../contexts/UserContext';
import { useSelector, useDispatch } from 'react-redux';
import DrawerMenu from "../drawerMenu/DrawerMenu";
import { FETCH_DRAWER_MENU } from "../../redux/actions";
import SidebarLinkItems from "../Sidebar/SidebarLinkItems";
import { setSelectedId, setSelectedTitle } from "../../redux/slices/selectItemDrawerMenu";
import { getFavoriteFiles } from '../../redux/FavoriteFiles/action';


const { Sider } = Layout;
const { SubMenu } = Menu;

const Sidebar = () => {

    const dispatch = useDispatch();


    const { drawerMenuData, loading, error } = useSelector((state) => state.drawerMenuData);

    const totalCount = useSelector((state) => state.totalCount);
    const {initialized} = useSelector((state) => state.initialize);


    const {
        token: { colorBgContainer },
    } = theme.useToken();
    const { userConfigs } = useUser();

    const { t } = useTranslation();

    const navigate = useNavigate();
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(userConfigs.collapsed);


    const onClickHome = () => {
        navigate('/');
        dispatch(setSelectedId(null));
        dispatch(setSelectedTitle(""));
    };


    const handleGetFavoriteFile = ()=>{
        dispatch(getFavoriteFiles())
    }


    useEffect(() => {
        setIsSidebarCollapsed(userConfigs.collapsed);
    }, [userConfigs.collapsed]);


    useEffect(() => {
        dispatch({ type: FETCH_DRAWER_MENU });
    }, []);

    return (
        <Sider
            breakpoint="lg"
            collapsedWidth="65"
            onBreakpoint={(broken) => {
                setIsSidebarCollapsed(broken);
                userConfigs.collapsed = broken;
            }}
            onCollapse={(collapsed, type) => {
                setIsSidebarCollapsed(collapsed);
                userConfigs.collapsed = collapsed;
            }}
            collapsed={isSidebarCollapsed}
            width={250}
            style={{
                background: colorBgContainer,
            }}
            className='sidebar'
        >
            {loading ? (
                <Skeleton active>
                    <List
                        itemLayout="horizontal"
                        dataSource={(new Array(5).fill({}))}
                        renderItem={() => (
                            <List.Item>
                                <Skeleton active />
                            </List.Item>
                        )}
                    />
                </Skeleton>
            ) : (

                <Flex gap="middle" vertical style={{ padding: 15 }}>
                    <Flex>
                        <HomeFilled className={userConfigs.collapsed ? 'home-menu-icon-collapse' : 'home-menu-icon'} onClick={onClickHome} />
                        {
                            !userConfigs.collapsed &&
                            <Button type="primary" className='home-menu' onClick={onClickHome}>
                                <div>{t('menu.home')}
                                    <span>{totalCount}</span>
                                </div>
                            </Button>
                        }

                    </Flex>
                    <DrawerMenu data={drawerMenuData} />
                </Flex>

            )}

            <Space wrap className='second-menu' style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', width: '100%' }}>
                <SidebarLinkItems icon={<SettingOutlined className='home-menu-icon-collapse' />} title={t('menu.setting')} config={!userConfigs.collapsed} link={"/setting"} />
                <div onClick={handleGetFavoriteFile}>
                    <SidebarLinkItems icon={<StarOutlined className='home-menu-icon-collapse' />} title={t('menu.favorites')} config={!userConfigs.collapsed} link={"/favorites"} />
                </div>
                <SidebarLinkItems icon={<DownloadOutlined className='home-menu-icon-collapse' />} title={t('menu.download')} config={!userConfigs.collapsed} link={"/download"} />
            </Space>
        </Sider>
    );
};

export default Sidebar;
